<template>
  <customModal :containermd="true" :bodysm="true" @closeModal="closeModalForms">
    <template #title>
      {{ $t("navigations.forms") }}
    </template>

    <template #body>
      <Teleport to="#wrapper">
        <div class="study_profile_modal__wrapper" v-if="showVisitForms">
          <div class="study_profile_modal__container custom-width mt-5">
            <div class="modal__title d-flex justify-content-between py-1 px-3">
              <h4 class="mb-0">{{ $t("navigations.forms") }}</h4>
              <div class="closebutton">
                 <span class="tooltip-wrapper pointer" style="float:right">
                  <i class="fa fa-times cursor-pointer" @click.prevent="closeModalForms"></i>
                  <span class="custom-tooltip closetooltipposition">Close</span>
                </span>
                
              </div>
            </div>

            <div class="modal-body overflow-block-form scroll_horizontal">
              <div class="form-group row my-lg-2">
                <div class="d-flex flex-column flex-lg-row mb-lg-0">
                  <div class="col-lg-12">
                    <table class="table features-table">
                      <p v-if="formItems == ''" class="mb-0 text-center">
                        {{ $t("navigations.no forms added") }}
                      </p>
                      <tbody>
                        <tr v-for="forms in formItems" :key="forms.id">
                          <td>{{ forms.templateName }} ({{ forms.version }})</td>
                          <td class="text-center">
                            <i class="fa fa-eye edit-delete" @click.prevent="viewForm(forms.template_ID)"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </Teleport>
    </template>
  </customModal>
</template>